import React, { useState } from "react";
import "./socialbtn.scss";
import facebook from "../../../assets/images/face.png";
import google from "../../../assets/images/google.png";
import { GrFacebookOption } from "react-icons/gr";
import { FcGoogle } from "react-icons/fc";
import FacebookLogin from "react-facebook-login";
import GoogleLogin from "react-google-login";
import * as userAuthAction from "redux/actions/AuthActions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import storage from "utils/storage";
import axios from "axios";
import * as authActions from "redux/actions/AuthActions";
import { ContactsOutlined } from "@material-ui/icons";
import config from "../../../config/index";
import errorMessages from "utils/errorMessages";
import { BsCursor } from "react-icons/bs";
// import { getToken } from "../../../firebase";
import { getSource } from '../../../utils/CommonService';

export const Socialbtn = (props) => {
  const [social, setsocial] = useState({});
  const [ error, setisError] = useState({isError: false, message: ""});
  const history = useHistory();
  const dispatch = useDispatch();
  /**
   * Success Response callback from facebook login
   * @param {Object} loginresult login response from facebook
   */
  const responseFacebook = async (loginresult) => {
    try {
      const loginSource = getSource(); // getting source from where user comes
      // const firebaseToken = await getToken();
      if(!loginresult?.email || !loginresult?.accessToken || !loginresult?.name) {
        onFbLoginFailure({status: config.ERROR_CODE.social_login.access_denied});
        return;
      }
      let fbdata = {
        provider: 2,
        email: loginresult?.email,
        token: loginresult?.accessToken,
        role: 0,
        name: loginresult?.name,
        imageUrl: loginresult?.picture?.data?.Url,
        lead_source: loginSource
      };
      // if (firebaseToken) {
      //   fbdata.firebase_token = firebaseToken;
      // }
      const response = await dispatch(authActions.recruitersociallogin(fbdata));
          if (response.value.success) {
            // set value of profile status in storage
            storage.set("profile_status", response.value.data.profile_status);
            if (response.value.data.profile_status){
              history.push("/jobs")
            }else {
              history.push("/user/basicdetail")
            }
          }
    }catch(err) {
      if(err.data && err.data.hasOwnProperty('error_code')) {
        if(err.data.error_code === 'ALREADY_REGISTERED')
        setisError({isError: true, message: errorMessages.AUTH_ERROR.ALREADY_REGISTERED_SOCIAL_EMP});
      }
      console.log("error in job seeker login",err);
      setTimeout( () => {setisError({isError: false, message: ""})},5000);
    }
  };
  /**
   * Error callback for facebook login
   * @param {Object} err error in facebook login
   */
  const onFbLoginFailure = (err) => {
    console.log("error in facebook login",err)
    setisError({isError: true, message: `Error in login via facebook : ${err.status}`});
    setTimeout( () => {setisError({isError: false, message: ""})},5000);
  }
  /**
   * Success Response callback from google login
   * @param {Object} res login response from google
   */
  const responseGoogle = async (res) => {
    try {
      const loginSource = getSource(); // getting source from where user comes
      // const firebaseToken = await getToken();
      if(!res?.profileObj?.email || !res?.tokenId || !res?.profileObj?.name) {
        onGoogleLoginFailure({error: config.ERROR_CODE.social_login.access_denied});
        return;
      }
      let data = {
        provider: 1,
        email: res?.profileObj?.email,
        token: res?.tokenId,
        role: 0,
        name: res?.profileObj?.name,
        imageUrl: res?.profileObj?.imageUrl,
        lead_source: loginSource
      };
      // if (firebaseToken) {
      //   data.firebase_token = firebaseToken;
      // }
      const response = await dispatch(authActions.recruitersociallogin(data))
          if (response.value.success) {
            // set value of profile status in storage
            storage.set("profile_status", response.value.data.profile_status);
            if (response.value.data.profile_status){
              history.push("/jobs")
            }else {
              history.push("/user/basicdetail")
            }
          }
    } catch(err) {
      if(err.data && err.data.hasOwnProperty('error_code')) {
        if(err.data.error_code === 'ALREADY_REGISTERED')
        setisError({isError: true, message: errorMessages.AUTH_ERROR.ALREADY_REGISTERED_SOCIAL_EMP});
      }
      console.log("error in job seeker login",err);
      setTimeout( () => {setisError({isError: false, message: ""})},5000)
    }
  };
  /**
   * Error callback for google login
   * @param {Object} err error in google login
   */
  const onGoogleLoginFailure = async (err) => {
    console.log("error in google login",err);
    if(['popup_closed_by_user','idpiframe_initialization_failed'].includes(err.error)) {
      return;
    }
    const errorMsg = config.ERROR_CODE.social_login.access_denied;
    setisError({isError: true, message: errorMsg});
    setTimeout( () => {setisError({isError: false, message: ""})},5000)
  }
  // Enabled Facebook button when checkbox is checked otherwise button will be disabled 
  const handleFacebookLogin = () => {
    if (props.isChecked == true) {
      return (
        <FacebookLogin
          appId="875006746387536"
          autoLoad={false}
          redirectUri={window.location.href}
          fields="name,email,picture"
          callback={responseFacebook}
          onFailure={onFbLoginFailure}
        />
      );
    } else {
      return (
        <FacebookLogin
          appId="875006746387536"
          autoLoad={false}
          redirectUri={window.location.href}
          fields="name,email,picture"
          callback={responseFacebook}
          onFailure={onFbLoginFailure}
          isDisabled={true}
        />
      );
    }
  };
  // Enabled Google button when checkbox is checked otherwise button will be disabled
  const handleGoogleLogin = () => {
    if (props.isChecked == true) {
      return (
        <GoogleLogin
          clientId="491235741230-cj0bk51lenjfgh3n9fcjf3eolokjtvac.apps.googleusercontent.com"
          buttonText="Login"
          onSuccess={responseGoogle}
          onFailure={onGoogleLoginFailure}
          cookiePolicy={"single_host_origin"}
          scope="profile"
          className="Google-btn"
        />
      );
    } else {
      return (
        <GoogleLogin
          clientId="491235741230-cj0bk51lenjfgh3n9fcjf3eolokjtvac.apps.googleusercontent.com"
          buttonText="Login"
          onSuccess={responseGoogle}
          onFailure={onGoogleLoginFailure}
          cookiePolicy={"single_host_origin"}
          scope="profile"
          className="Google-btn"
          isDisabled={true}
          disabled={true}
        />
      );
    }
  };
  return (
    <>
      <div className="d-flex  justify-content-between px-2 mt-3">
        <div className="fce">{handleFacebookLogin()}</div>
        <div className="ggl ">{handleGoogleLogin()}</div>
      </div>
      {error.isError && (
        <p className="text-danger text-center mt-1"> {error.message}</p>
      )}
    </>
  );
};

// "proxy": "http://68.183.87.38:3002",
